import { NgModule } from '@angular/core';
import { CmsConfig, provideConfig } from "@spartacus/core";
import { STORE_FINDER_FEATURE, StoreFinderRootModule } from "@spartacus/storefinder/root";

@NgModule({
  declarations: [],
  imports: [
    StoreFinderRootModule
  ],
  providers: [provideConfig(<CmsConfig>{
    featureModules: {
      [STORE_FINDER_FEATURE]: {
        module: () =>
          import('@spartacus/storefinder').then((m) => m.StoreFinderModule),
      },
    }
  }),
  ]
})
export class StoreFinderFeatureModule { }
